import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import { ENDPOINT } from 'constants/variables';
import { helpHttp } from 'service/HelpHttp';
import { warningErrorAction } from 'actions/ErrorActions';
import BlockIcon from '@mui/icons-material/Block';
import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage, setOrder, setSelectAll,setSelectAllPendig,setOrderBy,setRowsPerPage,updateSelectedRowsPending, updateSelectedRows} from 'reducers/paginationShippingsSlice';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Box from '@mui/material/Box';  
import Checkbox from '@mui/material/Checkbox';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage'; 
import Paper from '@mui/material/Paper'; 
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel'; 
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import TextField from '@mui/material/TextField';
import useTheme from '@mui/material/styles/useTheme';   
import visuallyHidden from '@mui/utils/visuallyHidden';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { NumericFormat } from 'components/utils/NumericFormat';  
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsShipping = [
  { id: 'date_shipping', numeric: false, disablePadding: false, label: 'Text_Date', canOrder: true, visible:true},
  { id: 'opt_tras_tradename', numeric: false, disablePadding: false, label: 'Text_RECIPIENT', canOrder: true, visible:true },
  { id: 'rel_trans_tradename', numeric: false, disablePadding: false, label: 'Text_CARRIER', canOrder: true, visible:true },
  { id: 'vehiclestore_licenseplate', numeric: false, disablePadding: false, label: 'Text_LICENSEPLATE', canOrder: true, visible:true },
  { id: 'totalamount', numeric: false, disablePadding: false, label: 'Text_AMOUNT', canOrder: true, visible:false },
  { id: 'id', numeric: false, disablePadding: false, label: 'Text_Code', canOrder: true, visible:true }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {

  const { order,orderBy,onRequestSort,t,showEmailButtonShipping, showFinishButtonhipping , showEditButtonShipping, showPrintButtonShipping, showDecaHistory, showDeleteButtonShipping, showFormShipping, showStoreShipping, showUserAccountShipping,  showTotal,  showFormDI, showReference, showOptTras, selectAll, selectAllPendig, handleChangSelectAll,  handleChangSelectAllPending,typeOfList} = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        {showEditButtonShipping &&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 14}} >
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        {showPrintButtonShipping &&
          <TableCell
            key='print'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} >
              {t('Button_Print_PDF')}
            </Typography>
          </TableCell>
        }
        {showDecaHistory &&
          <TableCell
            key='deca-download'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#f57c00", fontSize: 16, textTransform:"none"}}>
              {t('Button_DeCA_Download')}
            </Typography>
          </TableCell>
        }
        {showPrintButtonShipping &&
          <TableCell
            key='shipping'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#067330", fontSize: 16}} >
              {t('Button_Copy')}
            </Typography>
          </TableCell>
        } 
        {showEmailButtonShipping &&
          <TableCell
            key='email'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Print_EMAIL')}
            </Typography>
          </TableCell>
        }
        {showFinishButtonhipping &&
         <TableCell
            key='pending'
            align='center'
            padding='normal'
            sortDirection={false} 
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {(typeOfList==="1" || typeOfList==="3")?t('Text_Finish'):t('Text_Return')}
            </Typography>
            <Checkbox checked={(typeOfList==="1" || typeOfList==="3")?selectAll:selectAllPendig} style={{color:"#4e73df", fontSize: 16}}
              sx={{
                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
              }}
              onClick={(typeOfList==="1" || typeOfList==="3")?()=>handleChangSelectAll():()=>handleChangSelectAllPending()}
            />
          </TableCell>
        }   
        {headCellsShipping.map((headCell, indexhead) => (
          (headCell.visible || showTotal) &&
          (<TableCell
            key={indexhead}
            sx={headCell.id === 'id' ? { minWidth: 170, width: 170, whiteSpace: 'nowrap' } : undefined}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>)
        ))}  

        {showOptTras &&
          <TableCell
            key='dest_tras_tradename'
            align='left'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'dest_tras_tradename'}
              direction={orderBy === 'dest_tras_tradename' ? order : 'asc'}
              onClick={createSortHandler('dest_tras_tradename')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_LOADING')}
                {orderBy === 'dest_tras_tradename' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell> 
        }

        {showReference &&
          <TableCell
            key='number_shipping'
            align='left'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'number_shipping'}
              direction={orderBy === 'number_shipping' ? order : 'asc'}
              onClick={createSortHandler('number_shipping')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_Number')}
                {orderBy === 'number_shipping' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell> 
        }

        {showFormShipping && showFormDI &&
          <TableCell
            key='formdi_id'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 14}} > 
              {t('Text_FORMDI')}
            </Typography>
          </TableCell>
        }
        {showDeleteButtonShipping &&
          <TableCell
            key='delete'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 14}} > 
              {t('Text_DeleteOrAnnul')}
            </Typography>
          </TableCell>
        }
        {showStoreShipping &&
          <TableCell
            key='tradename'
            align='center'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'tradename'}
              direction={orderBy === 'tradename' ? order : 'asc'}
              onClick={createSortHandler('tradename')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_Store_Create')}
                {orderBy === 'tradename' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell>
        }
        {showUserAccountShipping &&
          <TableCell
            key='username'
            align='center'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'username'}
              direction={orderBy === 'username' ? order : 'asc'}
              onClick={createSortHandler('username')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_UserAcount_Create')}
                {orderBy === 'username' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell>
        } 
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegShipping, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegShipping).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataShipping']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingShipping =(props)=>{
  const { 
    dataShipping, 
    canViewCheck,
    setDataShipping,
    setFormPShipping, 
    numTotRegFilter,
    titleTable,
    setOpenDeleteRowShipping,
    setRowEditShipping, 
    showEditButtonShipping,
    showPrintButtonShipping,
    showDecaHistory,
    showDeleteButtonShipping,
    showFormShipping,
    showEmailButtonShipping,
    showFinishButtonhipping, 
    showStoreShipping,
    showUserAccountShipping,
    showTotal,
    showFormDI,
    showReference,
    showOptTras,
    setOpenViewFormDI,
    numTotRegShipping,
    activeOffsetShipping,
    rangeOffsetShipping,
    currencyOffsetShipping,
    setCurrencyOffsetShipping,
    setOpenCopyRowShipping,
    setViewPDF,
    typeOfList
  } = props;
  const {t,i18n} = useTranslation(['listDataShipping']);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.loginUser.token);
  const checkingRef = React.useRef(new Set());
  const [checkingIds, setCheckingIds] = useState([]);
  const [checkConfirmation, setCheckConfirmation] = useState(null);
  const toggleChequeado = async (row) => {
    if (!canViewCheck || checkingRef.current.has(row.id)) return;
    checkingRef.current.add(row.id);
    setCheckingIds([...checkingRef.current]);
    const chequeado = !row.chequeado;
    try {
      const result = await helpHttp().put(ENDPOINT, `shipping/chequeado/${row.id}`, token, chequeado);
      if (!result || result.err || result.status !== 'OK') throw new Error('Save failed');
      setDataShipping((prev) => prev.map((item) => item.id === row.id ? { ...item, chequeado } : item));
      setCheckConfirmation(null);
    } catch (error) {
      dispatch(warningErrorAction(t('Text_IncorrectData')));
    } finally {
      checkingRef.current.delete(row.id);
      setCheckingIds([...checkingRef.current]);
    }
  };

  const { currentPage, order, orderBy,rowsPerPage,selectAll,selectAllPendig,selectedRowsPending,selectedRows} = useSelector((state) => state.paginationShippings);
  const [countData,setCountData] = useState(dataShipping.length);
  const maxPage = Math.max(0, Math.ceil(countData / rowsPerPage) - 1);
  const page = Math.min(currentPage, maxPage);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataShipping.length) : 0);
   
  // Match the cells rendered before and after the amount column.
  const counterColSpan = 4
    + Number(Boolean(showEditButtonShipping))
    + 2 * Number(Boolean(showPrintButtonShipping))
    + Number(Boolean(showDecaHistory))
    + Number(Boolean(showEmailButtonShipping))
    + Number(Boolean(showFinishButtonhipping));
  const trailingColSpan = 1
    + Number(Boolean(showOptTras))
    + Number(Boolean(showReference))
    + Number(Boolean(showFormShipping && showFormDI))
    + Number(Boolean(showDeleteButtonShipping))
    + Number(Boolean(showStoreShipping))
    + Number(Boolean(showUserAccountShipping));

   useEffect(
    () => {
      setCountData(dataShipping.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataShipping.length) : 0);  
    },
    [dataShipping,page,setEmptyRows,rowsPerPage,countData]
  );
 
    useEffect(() => {
    const updatedRowsPending = dataShipping.map(item => ({
      ...item,
      isFinished: selectedRowsPending[item.id] || selectAll
    }));
    
    // Evita llamar setDataShipping si los datos no cambian
    if (JSON.stringify(updatedRowsPending) !== JSON.stringify(dataShipping))  {
      setDataShipping(updatedRowsPending);
    }
  }, [dataShipping, selectedRowsPending,setDataShipping,selectAll]);
  
  // Mantén los otros useEffect que ya tienes
  useEffect(() => {
    const updatedRows = dataShipping.map((item) => ({
      ...item,
      isPending: !item.annulled && (selectedRows[item.id] || selectAllPendig),
    }));
  
    // Solo actualiza si hay cambios reales
    if (JSON.stringify(updatedRows) !== JSON.stringify(dataShipping)) {
      setDataShipping(updatedRows);
    }
  }, [selectedRows,dataShipping,setDataShipping,selectAllPendig]); // Elimina dataPurchaseDelivery de las dependencias
   
  const handleChangeOffset = (event) => {
    setCurrencyOffsetShipping(event.target.value);
  };
  
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    dispatch(setOrder(isAsc ? 'desc' : 'asc')); // Actualiza Redux
    dispatch(setOrderBy(property)); // Actualiza Redux
  };  
  
  const handleChangePage = (event, newPage) => {
    dispatch(setCurrentPage(newPage)); // Guardar la página actual en Redux
  };
  
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage)); // Guardar el número de elementos por página actual en Redux
    dispatch(setCurrentPage(0)); // Reiniciar la página cuando cambian las filas por página
  };

  const openModalDeleteRowDepartment = (row) => {
    if (row.annulled) return;
    setRowEditShipping(row);
    setOpenDeleteRowShipping(true);
  };

  const openModalFormDIPDF = async (row) => {
    setRowEditShipping(row);
    setViewPDF(true);
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 1000000) return true;
    return false;
  };

  const openViewFormDI = (row) => {
    setRowEditShipping(row);
    setOpenViewFormDI(true);
  };

  const openViewCopyShippping = (row) => {
    if (row.annulled) return;
    setRowEditShipping(row);
    setOpenCopyRowShipping(true);
  }; 
 
  const handleChangSelectAll = () => { 
    const newSelectAll = !selectAll;
    const updatedSelectedRows = dataShipping.reduce((acc, item) => {
      acc[item.id] = newSelectAll;
      return acc;
    }, {});

    dispatch(setSelectAll(newSelectAll));
    dispatch(updateSelectedRowsPending(updatedSelectedRows));
    const updatedRows = dataShipping.map(item => ({
      ...item,
      isFinished: newSelectAll,
    })); 
    setDataShipping(updatedRows);
    setFormPShipping(prev => ({
    ...prev,
    }));
  };

  const handleChangSelectAllPending = () => {
    const newSelectAllPending = !selectAllPendig;
    const updatedSelectedRows = dataShipping.reduce((acc, item) => {
      acc[item.id] = !item.annulled && newSelectAllPending;
      return acc;
    }, {});
    dispatch(setSelectAllPendig(newSelectAllPending));
    dispatch(updateSelectedRows(updatedSelectedRows)); // Un único dispatch con todos los registros
    const updatedRows = dataShipping.map(item => ({
      ...item,
      isPending: item.annulled ? false : newSelectAllPending,
    }));
    setDataShipping(updatedRows);
    setFormPShipping(prev => ({
      ...prev,
    }));
  };

  const handleChangeEnabledRow = (row) => {
    const updatedRowsPending = dataShipping.map(item =>
      item.id === row.id ? { ...item, isFinished: !item.isFinished } : item
    );
    setDataShipping(updatedRowsPending); 
    dispatch(updateSelectedRowsPending({ 
      id: row.id, 
      isFinished: !row.isFinished 
    }));
    setFormPShipping(prev => ({
      ...prev,
    }));
  };

  const handleChangeEnabledPendingRow = (row) => {
    const updatedRows = dataShipping.map(item =>
      item.id === row.id ? { ...item, isPending: !item.isPending } : item
    );
    setDataShipping(updatedRows);
    dispatch(updateSelectedRows({
      id: row.id,
      isPending: !row.isPending,
    }));
    setFormPShipping((prev) => ({
      ...prev,
    }));
  }; 

   const listItems = stableSort(dataShipping, getComparator(order, orderBy))
   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
   .map((row, keyData) => {
     return (
      <TableRow hover tabIndex={-1} key={keyData}>
        {(showEditButtonShipping && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Link onClick={(event) => { if (row.annulled) event.preventDefault(); }} to={typeOfList==="1"?`/shippingdetail/${row.id}`:typeOfList==="2"?`/shippingdetailended/${row.id}`:`/shippingdetailhome/${row.id}`} >
              <IconButton size="large" className="edit-icon-button shipping-action-disabled" disabled={Boolean(row.annulled)}>
                <EditIcon style={{fontSize: 28}}/>
              </IconButton>
            </Link>
          </TableCell>
        } 
        {(showPrintButtonShipping && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
              <IconButton size="large" className="print-icon-button" onClick={() => openModalFormDIPDF(row)}>
                <PictureAsPdfIcon  style={{fontSize: 28}}/>
              </IconButton> 
          </TableCell>
        } 
        {(showDecaHistory && row.id !== "" && row.id !== null) &&
          <TableCell align="center">
            <Link to={typeOfList === "1"
              ? `/shippingdeca/${row.id}`
              : typeOfList === "2"
                ? `/shippingdecaended/${row.id}`
                : `/shippingdecabegin/${row.id}`}>
              <IconButton
                size="large"
                className="deca-icon-button"
                disabled={!row.hasDeca || !row.decaPublicToken}
                aria-label={t('Button_DeCA_Download')}
              >
                <QrCode2Icon style={{fontSize: 28}} />
              </IconButton>
            </Link>
          </TableCell>
        }
        {(showPrintButtonShipping && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            <IconButton size="large" className="copy-icon-button shipping-action-disabled" disabled={Boolean(row.annulled)} onClick={() => openViewCopyShippping(row)}>
              <ContentCopyIcon style={{ fontSize: 28 }} />
            </IconButton>
          </TableCell>
        )}
        {(showEmailButtonShipping && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Link onClick={(event) => { if (row.annulled) event.preventDefault(); }} to={typeOfList==="1"?`/shippingemail/${row.id}`:typeOfList==="2"?`/shippingemailended/${row.id}`:`/shippingemailbegin/${row.id}`} >
              <IconButton size="large" className="email-icon-button shipping-action-disabled" disabled={Boolean(row.annulled)} >
                <EmailIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Link>
          </TableCell>
        }
         {(showFinishButtonhipping && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Checkbox disabled={Boolean(row.annulled)} checked={(typeOfList==="1" || typeOfList==="3")?row.isFinished:row.isPending}
              sx={{
                color: '#4e73df',
                '&.Mui-checked': { color: '#4e73df' },
                '&.Mui-disabled': { color: '#c3c6d1' },
                '& .MuiSvgIcon-root': { fontSize: 28 },
              }}
              onClick={(typeOfList==="1" || typeOfList==="3")?()=>handleChangeEnabledRow(row):()=>handleChangeEnabledPendingRow(row)}
            />
          </TableCell>
        } 
        <TableCell align="center">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.date_shipping!==""?new Date(row.date_shipping).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):""}
           </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.dest_tras_tradename}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.rel_trans_tradename}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.vehiclestore_licenseplate}
          </Typography>
        </TableCell> 
        {showTotal && 
          <TableCell className="cell-total">
            <NumericFormat
              thousandSeparator=","
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
              allowNegative={false}
              isAllowed={withValueCap}
              id="totalamount"
              name="totalamount"
              suffix=" €"
              value={row.totalamount}
              className="numeric-field numeric-field--disabled numeric-field--wide"
              disabled
            />
          </TableCell> 
        }  
        <TableCell align="left" sx={{ minWidth: 170, width: 170, whiteSpace: 'nowrap' }}>
          <button
            type="button"
            style={{ whiteSpace: 'nowrap', flexWrap: 'nowrap', minWidth: 130, width: 'auto', flexShrink: 0, overflowWrap: 'normal', wordBreak: 'normal' }}
            className={`formgeneral-cancel-btn shipping-code-btn ${row.chequeado ? 'shipping-code-checked' : 'shipping-code-pending'}`}
            disabled={!canViewCheck || checkingIds.includes(row.id)}
            onClick={() => row.chequeado ? toggleChequeado(row) : setCheckConfirmation(row)}
            aria-label={`${row.ownshipping_id.toString().padStart(6, '0')} — ${row.chequeado ? t('Text_SHIPPING_Checked') : t('Text_SHIPPING_PendingCheck')}`}
          >
            {row.ownshipping_id.toString().padStart(6, '0')}
            {row.chequeado
              ? <CheckCircleRoundedIcon aria-hidden="true" sx={{ ml: 1, fontSize: '1.25em' }} />
              : <ScheduleRoundedIcon aria-hidden="true" sx={{ ml: 1, fontSize: '1.25em' }} />}
          </button>  
        </TableCell> 
        { showOptTras && 
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.opt_tras_tradename} 
            </Typography>
          </TableCell>
        }

        { showReference && 
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.number_shipping}
            </Typography>
          </TableCell>
        }  
        { showFormShipping &&  showFormDI && 
          ((row.id!=="" && row.id!==null && row.formdi_id!==null && row.formdi_id!=="" && row.formdi_id!=="0" && row.formdi_id!==0) ?
            <TableCell align="center">
              <IconButton size="large" className="shared-view-icon-button" onClick={() => openViewFormDI(row)}>
                <VisibilityIcon style={{ fontSize: 28 }} /> 
              </IconButton> 
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  &nbsp;({(row.ownformdi_id)})
              </Typography>  
            </TableCell>:
            <TableCell align="center">
              <IconButton size="large" disableRipple className="shared-view-icon-button-disabled">
                <VisibilityOffIcon style={{ fontSize: 28 }} /> 
              </IconButton> 
            </TableCell>)
        } 
        {(showDeleteButtonShipping && row.id!=="" && row.id!==null) &&
          <TableCell align="center">
             <IconButton
               size="large"
               className="delete-icon-button"
               disabled={Boolean(row.annulled)}
               aria-label={row.annulled ? t('Text_Shipping_Annulled') : row.hasDeca ? t('Button_AnnulShipping') : t('Button_Delete')}
               title={row.annulled ? t('Text_Shipping_Annulled') : row.hasDeca ? t('Button_AnnulShipping') : t('Button_Delete')}
               onClick={() => openModalDeleteRowDepartment(row)}
             >
              {row.hasDeca ? <BlockIcon style={{ fontSize: 28 }} /> : <DeleteIcon style={{ fontSize: 28 }} />}
            </IconButton>
            {row.annulled && <Typography sx={{ fontSize: 12, color: "#e74a3b" }}>{t("Text_Shipping_Annulled")}</Typography>}
          </TableCell>}
          {showStoreShipping  &&
            <TableCell align="left">
              <Typography style={{color:"#000000", fontSize: 16}} >
                {row.tradename}
              </Typography>  
            </TableCell>
        }
        {showUserAccountShipping  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.username}
            </Typography>  
          </TableCell>
        } 
      </TableRow>
    );
  });
  
  return(
    <>
     <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegShipping={numTotRegShipping} textOf={t('Text_Of')}/>
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead 
                order={order} 
                orderBy={orderBy} 
                onRequestSort={handleRequestSort}
                t={t} 
                showEmailButtonShipping={showEmailButtonShipping} 
                showFinishButtonhipping={showFinishButtonhipping} 
                showEditButtonShipping={showEditButtonShipping} 
                showPrintButtonShipping={showPrintButtonShipping} 
                showDecaHistory={showDecaHistory}
                showDeleteButtonShipping={showDeleteButtonShipping} 
                showFormShipping={showFormShipping} 
                showStoreShipping={showStoreShipping} 
                showUserAccountShipping={showUserAccountShipping} 
                showTotal={showTotal}
                showFormDI={showFormDI}
                showReference={showReference}
                showOptTras={showOptTras}
                selectAll={selectAll} 
                selectAllPendig={selectAllPendig} 
                handleChangSelectAll={handleChangSelectAll} 
                handleChangSelectAllPending={handleChangSelectAllPending} 
                typeOfList={typeOfList}/
              > 
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={14} />
                </TableRow>
                )}
                {showTotal &&
                  <TableRow> 
                    <TableCell colSpan={counterColSpan}>
                    </TableCell>
                      <TableCell className="cell-total">
                        <NumericFormat
                          thousandSeparator=","
                          decimalSeparator="."
                          decimalScale={2}
                          fixedDecimalScale
                          allowNegative={false}
                          id="totalpurchase"
                          name="totalpurchase" 
                          suffix=' €'
                          value={dataShipping.reduce((acc, row) => acc + parseFloat(row.totalamount || 0), 0)}
                          className="numeric-field numeric-field--disabled numeric-field--wide"
                          disabled
                        /> 
                      </TableCell> 
                      <TableCell colSpan={trailingColSpan}>
                    </TableCell>
                  </TableRow>
                }
              </TableBody> 
              <TableFooter>
                <TableRow>
                  {activeOffsetShipping && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetShipping"
                            name="currencyOffsetShipping"
                            value={currencyOffsetShipping}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetShipping
                            }}>
                            {rangeOffsetShipping.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )} 
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={17}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={page} // Página validada
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  /> 
                </TableRow>
              </TableFooter>              
            </Table>
          </TableContainer>
      </Box>
      <Dialog
        open={Boolean(checkConfirmation)}
        onClose={() => { if (!checkingIds.includes(checkConfirmation?.id)) setCheckConfirmation(null); }}
        PaperProps={{ className: 'my-dialog-paper', sx: { background: '#ffffff !important', backgroundImage: 'none', opacity: 1 } }}
        aria-labelledby="shipping-check-confirm-title"
      >
        <DialogTitle id="shipping-check-confirm-title" className="my-dialog-title" sx={{ color: '#2e7d32 !important' }}>
          {t('Text_SHIPPING_CheckConfirmTitle')} {String(checkConfirmation?.ownshipping_id ?? '').padStart(6, '0')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="my-dialog-contentText">
            {t('Text_SHIPPING_CheckConfirmMessage')}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="my-dialog-actions">
          <Button className="my-dialog-button-cancel" sx={{ color: '#2e7d32 !important', '&:hover': { backgroundColor: 'rgba(46, 125, 50, 0.08)' } }} disabled={checkingIds.includes(checkConfirmation?.id)} onClick={() => setCheckConfirmation(null)}>
            {t('Button_Cancel')}
          </Button>
          <Button variant="contained" className="my-dialog-button-copy" sx={{ background: 'linear-gradient(135deg, #2e7d32, #1b5e20) !important', '&:hover': { background: '#1b5e20 !important' } }} disabled={checkingIds.includes(checkConfirmation?.id)} onClick={() => toggleChequeado(checkConfirmation)}>
            {checkingIds.includes(checkConfirmation?.id) ? t('Text_Shipping_Saving') : t('Text_SHIPPING_CheckConfirmButton')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

TableSortingShipping.propTypes = {
  dataShipping: PropTypes.array.isRequired, 
  setDataShipping:PropTypes.func.isRequired, 
  setFormPShipping:PropTypes.func.isRequired,
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired, 
  setOpenDeleteRowShipping: PropTypes.func.isRequired, 
  setRowEditShipping: PropTypes.func.isRequired,     
  showEditButtonShipping: PropTypes.bool.isRequired,  
  showPrintButtonShipping: PropTypes.bool.isRequired,  
  showDeleteButtonShipping: PropTypes.bool.isRequired,
  showFormShipping: PropTypes.bool.isRequired,
  showEmailButtonShipping: PropTypes.bool.isRequired,
  showFinishButtonhipping: PropTypes.bool.isRequired,
  showStoreShipping: PropTypes.bool.isRequired,
  showUserAccountShipping: PropTypes.bool.isRequired,  
  showTotal: PropTypes.bool.isRequired,  
  showFormDI: PropTypes.bool.isRequired,  
  showReference: PropTypes.bool.isRequired,  
  showOptTras: PropTypes.bool.isRequired,  
  setOpenViewFormDI: PropTypes.func.isRequired,
  activeOffsetShipping: PropTypes.bool.isRequired,
  rangeOffsetShipping: PropTypes.array.isRequired,
  currencyOffsetShipping: PropTypes.number.isRequired,
  setCurrencyOffsetShipping: PropTypes.func.isRequired,
  setOpenCopyRowShipping: PropTypes.func.isRequired, 
  setViewPDF: PropTypes.func.isRequired ,
  typeOfList: PropTypes.string.isRequired 
};
  
export default TableSortingShipping;
